import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { pluck } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';
import { environment } from 'src/environments/environment';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import { DragRotateAndZoom, defaults as defaultInteractions } from 'ol/interaction';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Icon, Style } from 'ol/style';
import Swal from 'sweetalert2';
import { debounceTime, distinctUntilChanged, fromEvent } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MapBuilderService } from 'src/app/services/map-builder.service';
declare var bootstrap: any;

@Component({
  selector: 'app-business-page',
  templateUrl: './business-page.component.html',
  styleUrls: ['./business-page.component.css']
})

export class BusinessPageComponent implements OnInit {

  fullscreen_ModalStyle: string = `

    max-width: 100vw !important;

    width: 100%;

    height: 100vh;

    max-height: 100vh;

    margin: 0 !important;

  `;

  Info: any;

  map: any = {};

  width: number = 90;

  sliderSimilar: any = [];

  business_info: any = {};

  information_ads: any = [];

  mainImage_ads: any;

  list_businessGallery = [];

  list_AdsImages: any = [];

  list_AdsImagesShown: any = [];

  lst_links: any = [];

  lst_Album: any[] = [];

  current_Image: any = {};

  list_AdsImagesCounter: any

  isLogin: boolean;

  isAlbum: boolean = false;

  htmlContent: any;

  albumIndex: number = 0;

  userModel: FormGroup = this.formBuilder.group({

    iTaxiLon_User: new FormControl(this.otherService.getLocalStorage()?.Id),

    strSession: new FormControl(this.otherService.getLocalStorage()?.session),

    iTaxiLon_User_Citizen: new FormControl(0),

  });

  carouselOptions = {
    items: 1,
    rtl: true,
    loop: true,
    autoplay: false,
    autoplayTimeout: 3000, // Adjust the autoplay timeout as needed
    autoplayHoverPause: true,
    dots: false,
    nav: false, // Set to true if you want navigation arrows
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
  };

  constructor(
    private otherService: OtherService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private mapBuilderService: MapBuilderService,
  ) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe((params) => {

      this.userModel.get('iTaxiLon_User_Citizen').setValue(params.get('iTaxiLon_User'));

      this.accountService.resume_Info4User(this.userModel.value).subscribe((data) => {

        let res = JSON.parse(data.toString());

        console.log(res)

        if (res.strResume_SubCategory_strComment == '') {

          // return this.router.navigate([`/business`]);

        }

        if (res.bError) {

          return this.accountService.toastSwal('error', res.strError);

        }

        this.business_info = res;

        this.otherService.setTitle(res.strSiteTitle)

        this.width = (this.business_info.fScore * 65) / 5;

        let id = {
          iTaxiLon_User: this.business_info.iTaxiLon_User,
        };

        this.Info = this.otherService.getLocalStorage();

        // آگهی های مرتبط

        this.accountService.resumeSimlarList(id).subscribe((response) => {

          let res = JSON.parse(response.toString());

          this.sliderSimilar = res;

          // console.log(res);
        });

        // لینک های مرتبط

        this.accountService.Dyar_Business_DynamicLink({ iTaxiLon_User: params.get('iTaxiLon_User'), strSiteUrl: window.origin }).subscribe((response) => {

          this.lst_links = response;

        });

        // موقعیت کسب و کار

        setTimeout(() => {

          this.newOpenMap(res.fLon, res.fLat);

        }, 300);

        // یادداشت تنها برای شما قابل دیدن است و پس از حذف کسب و کار، پاک خواهد شد.

        setTimeout(() => {
          var textArea_Note = document.getElementById('textArea_');

          fromEvent(textArea_Note, 'keyup')
            .pipe(
              debounceTime(1000),
              pluck('target', 'value'),
              distinctUntilChanged()
            )
            .subscribe((data) => {
              var model_ = {
                iTaxiLon_User: this.Info?.Id,

                strSession: this.Info?.session,

                iTaxiLon_User_Resume:
                  this.business_info.iTaxiLon_User,

                strComment: data,
              };

              if (!this.isLogin) this.goToSupport();
              else this.accountService.Dyar_UpdateComment(model_);
            });
        }, 1000);

      });

      this.accountService.resume_Gallery_List(this.userModel.value).subscribe((data) => {
        let res = JSON.parse(data.toString());

        if (res.bError)
          return this.accountService.toastSwal('error', res.strError);

        this.list_AdsImages = res;
        this.list_AdsImagesCounter = this.list_AdsImages?.length - 3;


        // console.log(res);

        this.list_AdsImagesShown = res.slice(0, 3);
        this.list_AdsImages.forEach((item: any) => {
          // sanitize the URL properly

          item.strImage = item.strImage;

          // item.strImage = this.sanitizer.bypassSecurityTrustUrl(
          //   item.strImage
          // ) as SafeUrl;

          // if (item.bMain && item.bMain == true) this.mainImage_ads = item;
        });

        this.mainImage_ads = this.list_AdsImages[0];

        console.log(this.mainImage_ads)

        // let parts = this.mainImage_ads.split(',');
        //  this.mainImage_ads = parts[1];

        // console.log(this.list_AdsImages[0].strImage);
        // console.log(this.mainImage_ads);
      });

    });

    // Check user login status

    this.otherService.isUserLogin$.subscribe((condition) => {
      this.isLogin = condition;
    });

    this.http.get('../../../assets/basic/Ads_business_detail.html', { responseType: 'text', }).subscribe((data) => {

      this.htmlContent = data;

    });

  }

  ngOnDestroy() {

    this.otherService.setTitle('')
  }

  getBackgroundPosition(value: number) {
    const position = 3 * 20; // به عنوان مثال، هر واحد از مقدار معادل با 20 پیکسل می‌شود
    return `0px -${position}px`;
  }

  goToSupport() {
    if (!this.isLogin) {
      this.accountService.toastSwal('error', 'ابتدا وارد حساب کاربری خود شوید');
    } else {
      this.router.navigate(['support']);
    }
  }

  subString_Title(text: string, length?: number): string {

    if (length) {

      if (text?.length > length) {

        text = text.slice(0, length) + '...';

      }

    }

    else {

      if (text?.length > 35) {

        text = text.slice(0, 35) + '...';

      }

    }

    return text;

  }

  open_Business(item) {
    window.open(`/business/${item.iTaxiLon_User}`, '_blank');
  }

  chatWith_advertiser() {
    this.router.navigate(['/chat']);
  }

  callWith_advertiser() {
    window.location.href = 'tel:' + this.information_ads.strMobile;
  }

  next_Image() {
    const index = this.list_AdsImages.findIndex((x) => x == this.current_Image);

    if (index != -1) {
      if (index + 1 == this.list_AdsImages?.length)
        return (this.current_Image = this.list_AdsImages[0]);

      this.current_Image = this.list_AdsImages[index + 1];
    }
  }

  prev_Image() {
    const index = this.list_AdsImages.findIndex((x) => x == this.current_Image);

    if (index != -1) {
      if (index == 0)
        return (this.current_Image =
          this.list_AdsImages[this.list_AdsImages?.length - 1]);

      this.current_Image = this.list_AdsImages[index - 1];
    }
  }

  showComplete_Text() {
    let html = document.getElementById('span');

    html.classList.toggle('show-complete');
  }

  socialMedia(
    which: 'telegram' | 'whatsapp' | 'facebook' | 'instagram' | 'website'
  ) {
    if (which == 'telegram')
      return window.open(
        `https://t.me/${this.business_info.strTelegram}`,
        'blank'
      );

    if (which == 'whatsapp')
      return window.open(
        `https://wa.me/${this.business_info.strWhatsUp}`,
        'blank'
      );

    if (which == 'facebook')
      return window.open(
        `https://www.facebook.com/${this.business_info.strFacebook}`,
        'blank'
      );

    if (which == 'instagram')
      return window.open(
        `https://instagram.com/${this.business_info.strInstagram}`,
        'blank'
      );

    if (which == 'website')
      return window.open(`https://${this.business_info.strWebsite}`, 'blank');
  }

  shareVia() {
    if (navigator.share) {
      navigator

        .share({
          url: window.location.href,

          title: this.business_info.strTitle,
        })

        .then(() => console.log('اشتراک گذاری موفق'))

        .catch(() =>
          this.accountService.toastSwal('error', 'متاسفانه خطایی رخ داده است')
        );
    } else
      this.accountService.toastSwal(
        'error',

        'قابلیت اشتراک گذاری برای شما پشتیبانی نمی شود'
      );
  }

  likeBusiness() {
    if (!this.isLogin) {
      this.business_info.bLiked = false;

      Swal.fire({
        title: 'ابتدا وارد حساب کاربری خود شوید',

        icon: 'warning',

        showCancelButton: true,

        showConfirmButton: true,

        confirmButtonText: 'ورود',

        cancelButtonText: 'بازگشت',

        confirmButtonColor: '#10B981',
      }).then((result) => {
        if (result.isConfirmed) {
          const URL_BACK = `business/${this.userModel.get('iTaxiLon_User_Citizen')?.value
            }`;

          return this.router.navigate([`/login/${URL_BACK}`]);
        }
      });
    } else {
      ajax
        .post(
          environment.baseUrl + `Dyar_ResumeLike_SaveDelete`,

          {
            iResume_UserManager_User: this.business_info.iTaxiLon_User,
            ...this.userModel.value,
          },
          { 'Content-type': 'application/json' }
        )

        .subscribe({
          next: (value: any) => {
            let res = JSON.parse(value.response);

            if (res.bError) {
              this.business_info.bLiked = false;

              return this.accountService.toastSwal('error', res.strError);
            }

            this.business_info.bLiked = this.business_info?.bLiked
              ? !this.business_info?.bLiked
              : true;
          },

          error(err) {
            this.accountService.toastSwal(
              'error',
              'خطایی رخ داده است مجددا تلاش کنید'
            );

            this.business_info.bLiked = false;
          },
        });
    }
  }

  routeToMap(e) {
    const url = `https://www.google.com/maps?q=${e.fLat},${e.fLon}`;
    window.open(url, '_blank');
  }

  newOpenMap(...location) {

    this.map = this.mapBuilderService.createMap('test',location);

    [this.business_info].forEach((point: any) => {

      let iconSrc: string;

      if (point.bValid == true)
        iconSrc = '../../../assets/imgs/mapicon-32x32.png';

      if (point.bValid == false)
        iconSrc = '../../../assets/imgs/mapicon-32x32.png';

      const iconStyle = new Style({
        image: new Icon({
          src: iconSrc,

          size: [40, 38],

          anchor: [0.5, 1],
        }),
      });

      const marker = new Feature({
        geometry: new Point(olProj.fromLonLat([point.fLon, point.fLat])),
      });

      marker.setStyle(iconStyle);

      const vectorSource = new VectorSource({ features: [marker] });

      var vectorLayer = new VectorLayer({
        source: vectorSource,
        name: 'business-icon',
      } as any);

      marker.set('business_data', point);

      this.map.addLayer(vectorLayer);
    });
  }

  getSafeHtml(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  openGallery(item: any, index?: number) {

    this.lst_Album = this.list_AdsImages;

    console.log(this.lst_Album)

    this.isAlbum = false;

    this.albumIndex = this.lst_Album.indexOf(item);

    setTimeout(() => {

      this.isAlbum = true;

    }, 20);

    var myModal = new bootstrap.Modal(document.getElementById('galleryComp_Modal'), {});

    myModal.show();

  }


}
